// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'vivir-la-historia',
    appId: '1:887860548567:web:44db767b0d61ae7922f192',
    databaseURL: 'https://vivir-la-historia-default-rtdb.firebaseio.com',
    storageBucket: 'vivir-la-historia.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyDb-A6Y-lvwpANfAVNr1cttG0opUD5SLnU',
    authDomain: 'vivir-la-historia.firebaseapp.com',
    messagingSenderId: '887860548567',
    measurementId: 'G-PRV76ZMP66',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
